import React from 'react';
import ReactDOM from "react-dom";
import dom from './dom-util';
import {
  useFormik,
  getIn
} from 'formik';
import './css/customer-form.css';
import common from './common-util';
import config from './config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import dealer from './dealer';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

// A custom validation function. This must return an object
// which keys are symmetrical to our values/initialValues
const validate = values => {
  const errors = {};
  if (!values.firstName) {
    errors.firstName = 'Required';
  } else if (values.firstName.length > 15) {
    errors.firstName = 'Must be 15 characters or less';
  }

  if (!values.lastName) {
    errors.lastName = 'Required';
  } else if (values.lastName.length > 20) {
    errors.lastName = 'Must be 20 characters or less';
  }

  if (!values.email) {
    if (!values.phone) {
      errors.email = 'Required';
    }
    //errors.email = 'Required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email address';
  }
  if (!values.phone) {
    if (!values.email) {
      errors.phone = 'Required';
    }
  } else if (!/^\d{10}$/.test(values.phone)) {
    errors.phone = 'Invalid phone number';
  }

  if (!values.email && !values.phone) {
    errors.phone = 'Email or phone required';
  }

  return errors;
};

function getStyles(errors, fieldName) {
  if (getIn(errors, fieldName)) {
    return {
      borderBottom: '2px solid red',
      'outline': 'none'
    };
  }
}

function maxLengthCheck(object) {
  if (object.target.value.length > object.target.maxLength) {
    object.target.value = object.target.value.slice(0, object.target.maxLength)
  }
}

function formOnFocus() {
  if (common.isMobile()) {
    enableBodyScroll("tg-customerForm");
  }
}

function formOutOfFocus() {
  if (common.isMobile()) {
    disableBodyScroll("tg-customerForm");
  }
}

const SignupForm = () => {
  let customerFormClassName = "tg-customerForm";

  if (common.isMobile()) {
    customerFormClassName = "tg-customerMobileForm";
  }
  let settings = dealer.getChatClientSettings();
  let headerText = settings.uiSettings.headerText;
  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
      phone: ''
    },
    validate,
    onSubmit: (values, { setSubmitting, setErrors, setStatus, resetForm }) => {

      let firstName = values.firstName;
      let lastName = values.lastName;
      let email = values.email;
      let phone = values.phone;

      if (firstName && lastName && (email || phone)) {
        let event = {};
        let tgjoinmeetingEvent = document.createEvent("Event");
        tgjoinmeetingEvent.data = {};
        var customer = {
          "fName": values.firstName,
          "lName": values.lastName,
          "email": values.email,
          "phone": values.phone
        };
        tgjoinmeetingEvent.data.customer = customer;
        tgjoinmeetingEvent.data.source = "tg-video-chat";
        dealer.setCustomerInSession(tgjoinmeetingEvent.data);
        let dealerId = window.tgDealerId;
        let version = window.tgDealer.version;
        if (window.TGIframe && window.TGIframe()) {
          let frameIds = window.TGIframe().getFrameAndPopUpId(event, dealerId, version);
          let popupId = frameIds.popup;
          let iframeId = frameIds.iframe;
          tgjoinmeetingEvent.data.iframeId = iframeId;
          tgjoinmeetingEvent.data.popupId = popupId;
        }
        tgjoinmeetingEvent.initEvent("tg-join-meeting", true, true);
        window.dispatchEvent(tgjoinmeetingEvent);
        // console.log(JSON.stringify(values, null, 2));
        // resetForm({});
        setStatus({ success: true });
        dom.hide(config.customerFromId);
        clearAllBodyScrollLocks();
      }
    },
  });
  return (<div id="tg-customerForm" className={customerFormClassName}
    onFocus={formOnFocus()}
    onBlur={formOutOfFocus()}
    style={{ visibility: 'hidden' }}
  >
    <div className="tg-customerFromContainer">
      <div className="header">
        <div className="header-wrap">
          <span id="closeButton" onClick={() => {
            dom.setStyle(config.customerFromId, { 'visibility': 'hidden', 'opacity': 0, 'transform': 'translate(9999px)' });
            dom.show(config.tgvideoIconId)
            clearAllBodyScrollLocks()
          }
          }> <FontAwesomeIcon icon={faTimesCircle} /> </span>
          {/* <div className="logo-wrap">
          </div> */}
          <h3>
            {headerText}
          </h3>
          <div style={{ 'marginTop': '10%' }}>
            <label>
              Our team is available and happy to help. How can we help you today?
          </label>
          </div>
        </div>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <h4>Start a conversation</h4>
        <label>First Name</label>
        <div className="input-group-box">
          <div >
            <input id="firstName"
              name="firstName"
              type="text"
              onChange={
                formik.handleChange
              }
              value={
                formik.values.firstName
              }
              className="inputText"
              style={getStyles(formik.errors, 'firstName')}
              autoFocus
            />

          </div >
        </div>

        <div className="input-group-box" > <div >
          <label>Last Name</label>
          <input
            id="lastName"
            name="lastName"
            type="text"
            onChange={
              formik.handleChange
            }
            value={
              formik.values.lastName
            }
            className="inputText"
            style={getStyles(formik.errors, 'lastName')}
          />
        </div>
        </div>

        <div className="input-group-box" >
          <div >
            <label>Email</label>
            <input
              id="email"
              name="email"
              type="email"
              onChange={
                formik.handleChange
              }
              value={
                formik.values.email
              }
              className="inputText"
              style={getStyles(formik.errors, 'email')}
            />

          </div >
        </div>

        <div className="input-group-box" >
          <div >
            <label>Phone</label>
            <input
              id="phone"
              name="phone"
              type="number"
              maxLength="10"
              onChange={
                formik.handleChange
              }
              value={
                formik.values.phone
              }
              className="inputText"
              onInput={maxLengthCheck}
              style={getStyles(formik.errors, 'phone')}
            />

          </div >
        </div>
        <div style={{ textAlign: "center" }}>
          <button type="submit"> Start </button>
        </div>
      </form >
    </div>
  </div>
  );
};



function createForm(id) {
  
  const rootElement = document.getElementById(id);
  ReactDOM.render(< SignupForm />, rootElement);
}

export default createForm;